<div class="tooltip-container">
  <div *ngFor="let tooltip of tooltipService.externalTooltips">
    <app-tooltip-content *ngIf="tooltip.life > 0"[tooltip]="tooltip"></app-tooltip-content>
  </div>
  <div *ngFor="let tooltip of tooltipService.customerTooltips">
    <app-customer-tooltip *ngIf="tooltip.life > 0" [tab]="tab" [tooltip]="tooltip"></app-customer-tooltip>
  </div>
  <div *ngFor="let tooltip of tooltipService.flagEditors">
    <app-popup-flag-editor *ngIf="tooltip.life > 0" [tab]="tab" [tooltip]="tooltip"></app-popup-flag-editor>
  </div>
</div>
